import React from "react";
import htmlCss from "../images/html-css.png";
import tailwindCss from "../images/tailwind_css.png";
import javaScript from "../images/javascriptimage.png";
import java from "../images/java.png";
import springBoot from "../images/spring-boot.png";
import postgress from "../images/postgres.png";
import mysql from "../images/mysql.png";
import reactJsImage from "../images/react-js.png";
import kafka from "../images/kafka.png";
import redis from "../images/redis.png";
import { FaCode } from "react-icons/fa";
import { FaCodepen } from "react-icons/fa";
import { FaCodeFork } from "react-icons/fa6";
import { FaRegFileCode } from "react-icons/fa";
import { IoQrCode } from "react-icons/io5";
import { GoCodespaces } from "react-icons/go";

const FeaturesSection = () => {
  const technologies = [
    {
      id: 1,
      src: htmlCss,
      title: "HTML & CSS",
      style: "shadow-red-500",
    },
    {
      id: 2,
      src: javaScript,
      title: "Java Script",
      style: "shadow-yellow-500",
    },
    {
      id: 3,
      src: tailwindCss,
      title: "tailwind CSS",
      style: "shadow-green-400",
    },
    {
      id: 4,
      src: redis,
      title: "Redis",
      style: "shadow-red-500",
    },
    {
      id: 5,
      src: kafka,
      title: "Kafka",
      style: "shadow-white",
    },
    {
      id: 6,
      src: java,
      title: "Java",
      style: "shadow-red-500",
    },
    {
      id: 7,
      src: springBoot,
      title: "Spring Boot",
      style: "shadow-green-300",
    },
    {
      id: 8,
      src: postgress,
      title: "PostGre SQL",
      style: "shadow-blue-300",
    },
    {
      id: 9,
      src: mysql,
      title: "MySQL",
      style: "shadow-cyan-500",
    },
    {
      id: 10,
      src: reactJsImage,
      title: "React JS",
      style: "shadow-cyan-500",
    },
  ];

  const data = [
    {
      id: 1,
      icons: (
        <>
          <FaCode />
        </>
      ),
      title: "Reusable Code Components",
      description:
        "Develop modular and reusable code for efficient development and codebase maintenance",
    },
    {
      id: 2,
      icons: (
        <>
          <FaCodepen />
        </>
      ),
      title: "Configuration Management",
      description:
        "Efficiently manage application configurations to adapt to different environments and deployment scenarios.",
    },
    {
      id: 3,
      icons: (
        <>
          <FaCodeFork />
        </>
      ),
      title: "Dependency Management",
      description:
        "Ensure smooth integration and consistent functionality across projects with effective dependency handling.",
    },
    {
      id: 4,
      icons: (
        <>
          <FaRegFileCode />
        </>
      ),
      title: "Code Quality Assurance",
      description:
        "Maintain high-quality codebases and reduce technical debt with code quality standards and practices",
    },
    {
      id: 5,
      icons: (
        <>
          <IoQrCode />
        </>
      ),
      title: "Build Automation",
      description:
        "Streamline development workflows and ensure consistency in build outputs with automated processes.",
    },
    {
      id: 6,
      icons: (
        <>
          <GoCodespaces />
        </>
      ),
      title: "Version Control Management:",
      description:
        "Collaborate effectively and track code changes throughout the development lifecycle with version control.",
    },
  ];

  return (
    <div className="bg-gradient-to-b from-gray-800 to-black w-full h-full">
      <div className="max-w-screen-lg mx-auto flex flex-col justify-center w-full text-white pb-10">
        <div className="relative ">
          <div>
            <div className="w-full grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-8 text-center py-4 px-4">
              {technologies.map(({ id, src, title, style }) => (
                <div
                  key={id}
                  className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
                >
                  <img src={src} alt="" className="w-20 mx-auto object-cover" />
                  <p className="mt-4">{title}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="text-center">
            <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-5 lg:mt-10  tracking-wide">
              Easily build{" "}
              <span className="bg-gradient-to-r from-teal-500 to-teal-800 text-transparent  bg-clip-text">
                your code
              </span>
            </h2>
          </div>

          <div className="flex flex-wrap mt-10 lg:mt-10">
            {data.map(({ id, icons, title, description }) => (
              <div key={id} className="w-full sm:1/2 lg:w-1/3">
                <div className="flex">
                  <div className="flex mx-6 h-10 w-10 p-2 bg-neutral-900 text-teal-500 justify-center items-center rounded-full">
                    <span>{icons}</span>
                  </div>
                  <div>
                    <h5 className="mt-1 text-md">{title}</h5>
                    <p className="text-md mb-4 text-neutral-500">
                      {description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
